module.exports = __webpack_public_path__ + "static/media/7ICJ4.0c7ecb35.jpg";